// eslint-disable-next-line import/no-unresolved
import { Component } from 'preact';
import PropTypes from 'prop-types';

export default class Tooltip extends Component {
  render() {
    // eslint-disable-next-line react/prop-types
    const { message, children, mobileDirection } = this.props;

    return (
      <div className="tooltip-container">
        {children}
        <span className={`tooltip tooltip--mobile-${mobileDirection}`}>
          {message}
        </span>
      </div>
    );
  }
}

Tooltip.defaultProps = {
  mobileDirection: 'right',
};

Tooltip.propTypes = {
  mobileDirection: PropTypes.string,
};
